import { useField } from 'formik';
import React from 'react';
import { Props } from './SelectRegionModal';
import { SelectRegionModal } from './SelectRegionModal';

interface FormProps {
    name: string;
}

export const FormSelectRegionModal: React.FC<
    FormProps & Omit<Props, 'value' | 'onChange'>
> = ({ name, ...props }) => {
    const [field, , helpers] = useField(name);
    return (
        <SelectRegionModal
            {...props}
            value={field.value}
            onChange={helpers.setValue}
        />
    );
};
